import { useState } from 'react';
import { Link } from 'react-router-dom';
import { faqs } from '@/mocks/faqs';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,360px)_1fr] gap-10">
        <div>
          <span className="inline-flex items-center gap-2 text-sm text-accent-700">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-3xl md:text-4xl text-foreground-950">吃瓜之前,先看这几条</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于内容范围、分类方式和快速定位关键画面的方法,我们把最常被问到的问题集中放在这里。
          </p>
          <Link
            to="/about#contact"
            className="mt-6 inline-flex px-5 py-2.5 rounded-md text-sm whitespace-nowrap bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors cursor-pointer"
          >
            还有别的疑问,联系我们
          </Link>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div key={item.question} className="rounded-lg border border-background-200 bg-background-50">
                <h3>
                  <button
                    type="button"
                    aria-expanded={open}
                    onClick={() => setOpenIndex(open ? -1 : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="text-sm md:text-base text-foreground-900">{item.question}</span>
                    <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-background-100 text-foreground-600">
                      <i className={open ? 'ri-subtract-line' : 'ri-add-line'}></i>
                    </span>
                  </button>
                </h3>
                {open && (
                  <div className="px-5 pb-5 -mt-1">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.answer}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}